import React, { useState, useContext } from "react";
import styled from "styled-components";
import rectangle from "../assets/img/Rectangle.png";
import { useAuth } from "../context/auth";
import { navigate } from "@reach/router";
export default function AddTraitCondirm() {
  const Header = styled.h1`
    width: 70px;
    height: 24px;
    margin-top: 20px;
    margin-left: 14px;
    font-family: Poppins;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    color: #fffcf2;
    text-align: center;
  `;

  const BackBtn = styled.button`
    font-family: Poppins !important;
    font-style: normal;
    font-weight: bold;
    font-size: 2vh;
    text-align: center;
    letter-spacing: 0.005em;
    color: #fdfffc;
    background: transparent;
    border: none;
    cursor: pointer;
    margin-left: 20px;
    right: 3.57%;
    margin-top: 20px;
  `;

  const HeadImage = styled.img`
    border-radius: 20px;
    width: 85%;
  `;

  const NextBtn = styled.button`
    background: linear-gradient(
      90deg,
      #f89825 0%,
      #f26322 17.75%,
      #e5333b 46.66%,
      #c81d5e 86.72%,
      #a91e5e 97.37%
    );
    border-radius: 64px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px 50px;
    border: none;
    position: static;
    font-family: Poppins;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 26px;
    color: #fdfffc;
    margin: auto;
    text-align: center;
    letter-spacing: 0.005em;
  `;

  const UnderlinedText = styled.p`
    font-family: Poppins;
    color: #fdfffc;
    font-size: 12px;
    text-align: center;
    font-weight: 500;
    text-decoration: underline;
    text-decoration-color: #f89825;
    text-decoration-thickness: 2px;
  `;
  const { reg } = useAuth();
  return (
    <>
      <div>
        <BackBtn>
          <i class="fa fa-ellipsis-h"></i>
        </BackBtn>
      </div>
      <div>
        <Header>Sign Up</Header>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <HeadImage src={rectangle} />
      </div>
      <div className="mt-4">
        <NextBtn onClick={() => navigate("/trait-form")}>Add my trait</NextBtn>
      </div>
      <div className="mt-4">
        <UnderlinedText>
          I'll add my trait later. Create my account now.
        </UnderlinedText>
      </div>
    </>
  );
}
